import styled from 'styled-components';
import ButtonProps from '../../../../shared/types/props/button';
import Screen from '../../../../shared/utils/screen';

const KeySpace = styled.div<ButtonProps>`
  cursor: pointer;
  float: left;
  height: ${35 * Screen.widthRatio}px;
  left: ${(props) =>
    props.alternateKeyboard ? 164 * Screen.widthRatio + 'px' : 0};
  top: ${(props) =>
    props.alternateKeyboard ? -47 * Screen.widthRatio + 'px' : 0};
  margin-right: ${22 * Screen.widthRatio}px;
  position: relative;
  width: ${98 * Screen.widthRatio}px;
`;

export default KeySpace;
